/*
 * @Author: jiangxd
 * @Date: 2021-05-10 21:03:58
 * @LastEditTime: 2021-05-19 19:25:20
 * @LastEditors: jiangxd
 * @Description:
 * @FilePath: /rs_ips_maintence/src/views/components/linkForm/goodsLink.tsx
 */
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import DialogFactory from '../picker/dialogFactory';
import IPSDialog from '../picker/dialog';
import GoodsLink from '@/views/components/goodsLink/goodsLink.vue';

@DialogFactory
@Component({
  components: {
    GoodsLink,
  },
})
export default class GoodsLinkDialog extends IPSDialog {
  goodsList: string[] = [];

  confirm = false;

  title = '商品';

  width = '500px';

  footer = false;

  params: {};

  onCancel() {
    this.$emit('hidden');
  }

  onSelect(goodsList) {
    this.$emit('result', goodsList);
    this.onCancel();
  }

  renderContent(h) {
    return <GoodsLink ref="goodsLink" onCloseHandle={this.onCancel.bind(this)} onCancel={this.onCancel.bind(this)} type="select" goodsInfo="select" selectOne={true} selectDisabled={true} params={this.params} onSelect={this.onSelect.bind(this)} />;
  }
}
